import { Row, Col, Card, Form } from "react-bootstrap";
import Badge from "react-bootstrap/Badge";

const DEFAULT_SLIDER_VALUE = 5;

const EXPERTISE_FIT = {
  BIJSCHOLEN: 1,
  BUITEN_INTERESSEGEBIED: 2,
};

const semesterLabel = s =>
  s === 1 ? "Semester 1" : s === 2 ? "Semester 2" : "Jaarvak";

function OlaCard({ ola, pref = {}, onOlaPrefChange, showOpo = false }) {
  const expertiseFit = pref.expertiseFit ?? null;
  const isFilled = pref.passionScore != null || expertiseFit != null;

  const handleModeChange = val => {
    if (val === null) {
      const updates = { expertiseFit: null };
      if (pref.passionScore == null) updates.passionScore = DEFAULT_SLIDER_VALUE;
      onOlaPrefChange(ola.ID, updates);
    } else {
      onOlaPrefChange(ola.ID, { expertiseFit: val });
    }
  };

  const campusLabels = [...new Set(
    ola.phases.map(({ campusName }) => campusName).filter(Boolean)
  )];

  const phaseNames = [...new Set(
    ola.phases.map(({ phaseName }) => phaseName).filter(Boolean)
      .map(n => /^\d/.test(n) ? n[0] : n)
  )];

  return (
    <Card className={`mb-3 ${isFilled ? "border-success" : "border-warning"}`}>
      <Card.Body>
        <Row className="align-items-center g-3">
          <Col md={4}>
            <strong>{ola.name}</strong>
            {showOpo && ola.opoName && (
              <div className="text-muted small">{ola.opoName}</div>
            )}
            <div className="mt-1">
              <Badge bg="secondary" className="me-1">{semesterLabel(ola.semester)}</Badge>
              {phaseNames.length > 0 && (
                <Badge bg="light" text="dark" className="border me-1">{phaseNames.length === 1 ? "Fase" : "Fasen"}: {phaseNames.join(", ")}</Badge>
              )}
              {campusLabels.map(c => (
                <Badge key={c} bg="light" text="dark" className="me-1">{c}</Badge>
              ))}
            </div>
          </Col>

          <Col md={8}>
            <Form.Label className="mb-1">
              Algemene voorkeur:&nbsp;
              {expertiseFit != null
                ? <span className="text-muted">—</span>
                : pref.passionScore != null
                  ? <strong className="text-primary">{pref.passionScore}/10</strong>
                  : <span className="text-warning fst-italic">nog niet ingevuld</span>
              }
            </Form.Label>
            <Form.Range
              min={1} max={10} step={1}
              value={expertiseFit != null ? DEFAULT_SLIDER_VALUE : (pref.passionScore ?? DEFAULT_SLIDER_VALUE)}
              disabled={expertiseFit != null}
              className={expertiseFit != null ? "opacity-25" : ""}
              onChange={e => onOlaPrefChange(ola.ID, { passionScore: parseInt(e.target.value, 10) })}
            />
            <div className="hoewist-slider-labels">
              <span>1 - Niet graag</span>
              <span>10 - Heel graag</span>
            </div>

            <div className="mt-2">
              <Form.Check
                type="radio"
                id={`mode-slider-${ola.ID}`}
                name={`mode-${ola.ID}`}
                label="Voorkeursscore via schuifbalk"
                checked={expertiseFit == null}
                onChange={() => handleModeChange(null)}
              />
              <Form.Check
                type="radio"
                id={`mode-bijscholen-${ola.ID}`}
                name={`mode-${ola.ID}`}
                label="Sluit minder goed aan bij mijn expertise, maar ik wil me hierin bijscholen."
                checked={expertiseFit === EXPERTISE_FIT.BIJSCHOLEN}
                onChange={() => handleModeChange(EXPERTISE_FIT.BIJSCHOLEN)}
              />
              <Form.Check
                type="radio"
                id={`mode-buiten-${ola.ID}`}
                name={`mode-${ola.ID}`}
                label="Sluit minder goed aan bij mijn expertise en valt buiten mijn interessegebied."
                checked={expertiseFit === EXPERTISE_FIT.BUITEN_INTERESSEGEBIED}
                onChange={() => handleModeChange(EXPERTISE_FIT.BUITEN_INTERESSEGEBIED)}
              />
            </div>
          </Col>
        </Row>

        <Row className="mt-3">
          <Col>
            <Form.Control
              as="textarea"
              rows={1}
              placeholder="Opmerking (optioneel)"
              value={pref.comment ?? ""}
              onChange={e => onOlaPrefChange(ola.ID, { comment: e.target.value || null })}
            />
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
}

export default OlaCard;
